import React, { Component } from 'react';
import { List, Avatar } from 'antd';
import moment from 'moment';

export default class PositionBrowerList extends Component {
  static propTypes = {

  };

  renderItem = (item) => {
    let desc = (<div><span>查看了</span> <a >{item.companyName}</a> 的 <a>{item.name}</a>    </div>);
    return (<List.Item>
      <List.Item.Meta
        avatar={<Avatar src={item.img} />}
        title={<div><span >{item.nickName}</span><a>({item.phone})</a></div>}
        description={desc}
      />
    </List.Item>)

  }

   render() {
    const { positionBrowerList } = this.props;
    return (
      <div className="home-data-tab">
        <List
          bordered={false}
          header=""
          dataSource={positionBrowerList}
          renderItem={this.renderItem}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/PositionBrowerList.js